<template>
  <div class="layout">
    <div class="layout__header">
      <div class="layout__title">
        <h3>Lista de abonos realizados</h3>
      </div>
      <div class="card__controls">
        <button @click="agregarAbono" class="btn-success" type="button"><i class="fa fa-plus"></i> <span>Agregar</span></button>
        <modal name="abono" height="auto" width="60%" scrollable>
          <abono :saldo="saldo" :idComprobante="idComprobante" @aceptar="aceptarAbono" @cancelar="cancelarAbono"
            v-model="selectedAbono"></abono>
        </modal>
      </div>
    </div>
    <div class="table-responsive">
      <vue-good-table 
        :columns="[
          {
            label: 'Fecha',
            field: 'fecha_abono',
            filterable: true
          },
          {
            label: 'Tipo',
            field: 'descripcion_tipo_abono',
            filterable: true
          },
          {
            label: 'Valor',
            field: 'valor',
            filterable: true,
            type : 'decimal'
          },
          {
            label: 'Obs./Referencia',
            field: 'obs_referencia'
          },
          {
            label: 'Banco/Retención',
            field: 'banco_retencion'
          },
          {
            label: 'Acciones',
            field: 'actions'
          }
        ]"
        :rows="abonos" 
        :search-options="{
          enabled: true,
          placeholder: 'Buscar...'
        }"
        :pagination-options="{
          enabled: false
        }"
        styleClass="vgt-table">
        <template slot="table-row" slot-scope="props">
          <span v-if="props.column.field == 'actions'">
            <button type="button" @click="editarAbono(props.index)" class="btn-info btn--text"><i class="fa fa-edit"></i></button>
            <button type="button" @click="eliminarAbono(props.index)" class="btn-danger btn--text"><i class="fa fa-trash"></i></button>
          </span>
          <span v-else-if="props.column.field == 'fecha_abono'">
            {{ moment(new Date(props.formattedRow[props.column.field])).format('DD/MM/YYYY') }}
          </span>
          <span v-else>
            {{((props.column.prefijo!=undefined)?'$':'')}}{{(!props.column.numeric)?props.formattedRow[props.column.field]:parseFloat(props.formattedRow[props.column.field]).toLocaleString(locale)}}
          </span>
        </template>
      </vue-good-table>
    </div>
    <div class="row mt-2">
      <div class="col-xs-12 col-md-4">
        <input-field vMoney :format="money" placeholder="$ ##.##" readonly id="totalAbonado" v-model="totalAbonado">
          <span>Total abonado</span>
        </input-field>
      </div>
      <div class="col-xs-12 col-md-4">
        <input-field vMoney :format="money" placeholder="$ ##.##" readonly id="totalAbonado" v-model="totalComprobante">
          <span>Total de comprobante</span>
        </input-field>
      </div>
      <div class="col-xs-12 col-md-4">
        <input-field vMoney :format="money" placeholder="$ ##.##" readonly id="totalAbonado" v-model="saldo">
          <span>Saldo</span>
        </input-field>
      </div>
    </div>
  </div>
</template>

<script>
export default {
    props : {
        idComprobante : {
            type : String,
            required : true
        }
    },
    data : function () {
        return {
            abonos : [],
            totalAbonado : 0,
            totalComprobante : 0,
            saldo : 0,
            selectedAbono : {
                fecha_abono : moment(new Date()).format('YYYY-MM-DD'),
                tipo_abono : '',
                valor : 0, 
                obs_referencia : '',
                banco_retencion : '',
                id_abono : ''
            },
            url : url,
            money : money,
            moment : moment
        };
    },
    methods : {
        editarAbono : function (index) {
            this.selectedAbono = JSON.parse(JSON.stringify(this.abonos[index]));
            this.$modal.show('abono');
        },
        eliminarAbono : function (index) {
            let that = this;
            swal({
                title: '¿Desea eliminar este abono?',
                text: "Se requiere de confirmación.",
                type: 'warning',
                showCancelButton: true,
                confirmButtonText : 'Crear nueva',
                cancelButtonText : 'Cancelar'
                }).then((result) => {
                    if (result.value)
                    {
                        axios.post(that.url + '/abonos/' + that.abonos[index].id_abono, {
                            _method : 'DELETE'
                        }).then(function (response) {
                            swal('El abono fue eliminado con éxito.', 'Aviso', 'success');
                            that.cargarAbonos();
                        });
                    }
            });
        },
        agregarAbono : function () {
            this.selectedAbono = {
                fecha_abono : new Date(),
                tipo_abono : '',
                valor : 0, 
                obs_referencia : '',
                banco_retencion : '',
                id_abono : ''
            };
            this.$modal.show('abono');
        },
        cargarAbonos : function () {
            let that = this;
            axios.get(this.url + '/abonos/' + this.idComprobante).then(function (response) {
                that.abonos = response.data.abonos;
                let comprobante = response.data.comprobante;
                that.totalAbonado = comprobante.total_pagado;
                that.totalComprobante = comprobante.valor_total;
                that.saldo = round(parseFloat(comprobante.valor_total) - parseFloat(comprobante.total_pagado));
            });
        },
        aceptarAbono : function (abono) {
            this.cargarAbonos();
            this.$modal.hide('abono');
            swal('El abono fue almacenado exitósamente.', 'Realizado', 'success');  
            
        },
        cancelarAbono : function () {
            this.$modal.hide('abono');
        }
    },
    mounted : function () {
        this.cargarAbonos();
    }
}
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/forms/comprobantes/ListaAbonos.vue